import { client } from '../../../../../actions';
import { authHeader } from '../../../../../helpers/auth-header';

export const fetchAdminInfo = async (companyId) => {
  const url = `/Admin/company/${companyId}`;

  const response = await client.get(url, {
    headers: authHeader(),
  });

  return response.data;
};
